import { useState, useEffect } from 'react'
import { Nav, Button } from 'react-bootstrap'
import { Info } from 'lucide-react'
import { useParams } from 'react-router-dom'

const groupTabs = ['My Groups', 'Invitations']
const sortOptions = ['Recently Active', 'Alphabetically', 'Date Created']

export default function GroupsSection() {
  const { id } = useParams() // Get ID from URL
  const requestId = id // Use id as requestId
  const [activeTab, setActiveTab] = useState('Invitations')
  const [selectedSort, setSelectedSort] = useState(sortOptions[0])
  const [invitations, setInvitations] = useState([])
  const [loading, setLoading] = useState(false)

  const token = localStorage.getItem('jwttoken') // Retrieve JWT token

  useEffect(() => {
    console.log('Token:', token) // Debug token
    console.log('Fetching invitations for requestId:', requestId) // Debug requestId

    if (activeTab === 'Invitations' && requestId) {
      setLoading(true)
      fetch(`https://kaasbackend.vetrinahealthcare.com/socialapp/group-join-requests/3/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => {
          console.log('Response status:', res.status) // Debug response status
          return res.json()
        })
        .then((data) => {
          console.log('API Response:', data) // Debug response data
          setInvitations(Array.isArray(data) ? data : [data]) // Handle array or single object response
        })
        .catch((err) => console.error('Error fetching invitations:', err))
        .finally(() => setLoading(false))
    }
  }, [activeTab, requestId, token])

  return (
    <div className='card shadow-sm'>
      <div className='card-body p-0'>
        {/* Tabs Navigation */}
        <Nav className='border-bottom gap-4 px-4'>
          {groupTabs.map((tab) => (
            <Nav.Item key={tab}>
              <Nav.Link
                onClick={() => setActiveTab(tab)}
                className={`py-3 px-1 border-bottom border-3 ${
                  activeTab === tab
                    ? 'border-primary text-primary'
                    : 'border-transparent text-muted'
                }`}
              >
                {tab}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>

        <div className='p-4'>
          {activeTab === 'Invitations' ? (
            <>
              <h5 className='mb-4'>Group Invites</h5>
              {loading ? (
                <p className='text-muted'>Loading invitations...</p>
              ) : invitations.length > 0 ? (
                invitations.map((invite) => (
                  <div key={invite.id} className='border p-3 rounded mb-3'>
                    <h6 className='mb-1'>{invite.group.name}</h6>
                    <p className='text-muted small'>
                      Invited by: {invite.requested_by.name} (
                      {invite.requested_by.email}) <br />
                      Status: {invite.status}
                    </p>
                    <Button variant='primary' size='sm' className='me-2'>
                      Accept
                    </Button>
                    <Button variant='outline-danger' size='sm'>
                      Decline
                    </Button>
                  </div>
                ))
              ) : (
                <div className='d-flex align-items-center gap-2 text-muted'>
                  <div
                    className='bg-primary rounded-circle p-2 d-flex align-items-center justify-content-center'
                    style={{ width: '32px', height: '32px' }}
                  >
                    <Info size={16} className='text-white' />
                  </div>
                  <span>You have no outstanding group invites.</span>
                </div>
              )}
            </>
          ) : (
            <>
              <h5 className='mb-4'>My Groups</h5>
              <p className='text-muted'>Your groups will be displayed here.</p>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
